module.exports = __webpack_public_path__ + "static/img/ye.c7f96a73.svg";